import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const StyledEmptyStateContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: 'var(--bg-color)',
  padding: '32px',
});

interface StyledImageProps {
  width?: string;
  height?: string;
}

export const StyledEmptyStateImage = styled('img', {
  shouldForwardProp: (prop) => prop !== 'width' && prop !== 'height',
})<StyledImageProps>(({ width = 'auto', height = 'auto' }) => ({
  marginBottom: '16px',
  width: width,
  height: height,
}));

export const StyledEmptyStateTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: 500,
  color: 'var(--primary-navy)',
  marginBottom: '8px',
});

export const StyledEmptyStateSubtitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  color: 'var(--instructions)',
  textAlign: 'center',
  maxWidth: '400px',
});
